export const mutations = {
  setLeaguesRelationship: (state, payload) => {
    state.leaguesRelations = payload;
  },
  setLeague: (state, payload) => {
    state.league = payload;
  },
  setLeagues: (state, payload) => {
    state.leagues = payload;
  }
};
